import React, { useState, useEffect } from 'react';

import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  Input,
} from 'antd';

import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = '/tramites/estados-de-fichas/';

const EstadoDeFichas = () => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await API.get(baseURI);
      if (response?.status === 200) {
        setData(response.data);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    fetchData();

    return () => API.source.cancel;
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setSelectedRowKeys([]);
    form.resetFields();
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: '100%',
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          rowKey="id"
          mobileColIndex={0}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickExpand: () => setVisible(true),

          }}
          allowExpand
        />
        <Modal
          open={visible}
          title={(
            <FormSubmitControls
              label="Vista Completa"
              onCancel={onCancel}
            />
          )}
          footer={null}
          closable={false}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
          >
            <Col span={24}>
              <Form.Item
                name="descripcion"
                label="Descripción"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
      </Spin>
    </Row>
  );
};
export default EstadoDeFichas;
